import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Process from "@/components/Process";
import AiSurvivalSchool from "@/components/AiSurvivalSchool";
import Subsidiaries from "@/components/Subsidiaries";
import About from "@/components/About";
import CtaBanner from "@/components/CtaBanner";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

// All sections are imported eagerly: the page is fully prerendered to static
// HTML (see scripts/prerender.mjs), so the initial paint comes from HTML rather
// than JS, and eager imports keep the prerendered markup inline + hydratable.
export default function Home() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Process />
        <AiSurvivalSchool />
        <Subsidiaries />
        <About />
        <CtaBanner />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
